<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close transfer :loading="loading">
			<template #default>
				<div ref="logistictrace_custom_form"></div>
				<vxe-grid ref="list" v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
				<hitchhiking-form :data="hitchhikingData" :warehouseid="warehouseid" :policytype="policytype" :tabledata="tabledata" ref="hitchhikingForm" @modalhide="hitchhikingData=[]" @submit="hitchhikingFormSubmit" />
				<goods-box :data="currentrow" ref="goodsBox" @submit="goodsBoxSubmit" />
				
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
		
	</div>
</template>
<style scoped>

</style>
<script>
	// const formjson = {
	// 	title: '表单',
	// 	rule: {
	// 		"width": "800",
	// 		"height": "600",
	// 		"fApi": [],
	// 		"rule": [
	// 			{
	// 				"type": "$input",
	// 				"field": "input",
	// 				"title": "input",
	// 				"value": null,
	// 				"hidden": false,
	// 				"props": {
	// 					"readonly":true
	// 				},
	// 				"validate": [{
	// 					"required": false,
	// 					"message": "必填项"
	// 				}]
	// 			},
	// 			{
	// 				"type": "$datePicker",
	// 				"field": "time",
	// 				"title": "time",
	// 				"props": {
	// 					"type": "date",
	// 					"disabled":true
	// 				},
	// 				"value": null,
	// 				"hidden": false,
	// 				"validate": [{
	// 					"required": false,
	// 					"message": "必填项"
	// 				}]
	// 			},
	// 			{
	// 				"type": "$emun",
	// 				"field": "emun",
	// 				"title": "emun",
	// 				"value": null,
	// 				"hidden": false,
	// 				"props": {
	// 					"name": "enable"
	// 				},
	// 				"validate": [{
	// 					"required": false,
	// 					"message": "必填项"
	// 				}]
	// 			},
	// 			{
	// 				"type": "$upload",
	// 				"field": "upload",
	// 				"title": "upload",
	// 				"value": null,
	// 				"hidden": false,
	// 				"props": {},
	// 				"validate": [{
	// 					"required": false,
	// 					"message": "必填项"
	// 				}]
	// 			}
	// 		],
	// 		"option": {
	// 			"form": {
	// 				"labelWidth": "80px",
	// 				"hideRequiredAsterisk": false,
	// 				"showMessage": false,
	// 				"inlineMessage": false
	// 			},
	// 			"global": {
	// 				"*": {
	// 					"props": {
	// 						"el": true,
	// 						"size": "small",
	// 						"disabled": false
	// 					},
	// 					"col": {
	// 						"span": 24,
	// 						"offset": 0
	// 					}
	// 				},
	// 				"el-divider": {
	// 					"wrap": {
	// 						"show": false
	// 					},
	// 					"native": false,
	// 					"col": {
	// 						"span": 24,
	// 						"offset": 0
	// 					},
	// 					"props": {
	// 						"contentPosition": "left"
	// 					}
	// 				}
	// 			},
	// 			"submitBtn": false,
	// 			"resetBtn": false
	// 		}
	// 	}
	// }
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import hitchhikingForm from './hitchhiking.vue'
	import goodsBox from '../box/goods.vue'
	
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				loading:false,
				modal_model:false,
				modal_title: '采购单配置',
				modal_width:1000,
				modal_height:800,
				sourcedata:[],
				tabledata:[],
				hitchhikingData:[],
				currentrow:{},
				warehouseid:0,
				policytype:0,
				list_footerField:[
					{field:'quantity',toFixed:0},
					{field:'specCode',toFixed:0},
					{field:'sum',toFixed:2}
				]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			modal_init() {
				this.sourcedata = JSON.parse(JSON.stringify(this.data))
				this.$emit('show')
			},
			list_beforeCreateGrid(gridOptions) {
				gridOptions.height = 650
				gridOptions.toolbarConfig = {
					size: 'mini',
					perfect: false,
					buttons: [{
						name: '自定义搭车',
						status: 'primary',
						code: 'hitchhiking'
					}],
					customConfig: {
						storage: true
					},
					custom: true,
					refresh: true,
					zoom: true,
					tools: []
				}
				gridOptions.columns = [{
						treeNode:true,
						type: 'seq',
						title: '#',
						width:80,
						fixed:'left'
					},{
						field: 'warehouseID',
						title: '仓库ID',
						visible:false,
						width:100
					},{
						field: 'warehouseid',
						title: '仓库',
						editRender: {
							name: '$warehouse',
							props: {
								readonly:true
							},
							events: {
											
							}
						},	
						width:100
					},{
						field: 'supplierID',
						title: '供应商ID',
						width:100,
						visible:false
					},{
						field: 'supplierName',
						title: '供应商',
						width:100
			
					},{
						field: 'specCode',
						title: '商品编码',
						width:100,
						slots: {
							default: ({row}) => {
								if(row.hitchhiking){
									return [
										<el-tag size="mini" effect="dark" type="success" style="margin-right:2px;">撘</el-tag>,
										<span>{row.specCode}</span>
									]
								}else{
									return [<span>{row.specCode}</span>]
								}
								
							}
						}
						
					},{
						field: 'goodsname',
						title: '商品名称',
						width:100
					},{
						field: 'goodsmodel',
						title: '商品规格',
						width:100
					},{
						field: 'recommendlevel',
						title: '推荐等级',
						width:100
					},{
						field: 'quantity',
						title: '数量',
						width:100,
						fixed:'right'
					},{
						field: 'price',
						title: '单价',
						width:100,
						fixed:'right'
					},{
						field: 'sum',
						title: '金额',
						width:100,
						fixed:'right'
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 85,
						slots: {
							default: ({row}) => {
								if(row.parentid){
									return [<el-button style="color:#F56C6C;" type = "text" size = "mini" onClick = {() => {this.delete(row)}}>删除</el-button>]
								}else{
									return [<el-button style="color:#409EFF;" type = "text" size = "mini" onClick = {() => {this.add(row)}}>搭车采购</el-button>]
								}
								
							}
						}
					}
				]
				gridOptions.formConfig = false
				// gridOptions.editRules = {
				// 	c: [{
				// 		required: true
				// 	},{
				// 		validator({cellValue,row}){
				// 			return new Promise((resolve,reject)=>{
				// 				if( true ){
				// 					reject(new Error('自定义错误'))
				// 				}else{
				// 					resolve()
				// 				}
								
				// 			})
				// 		}
				// 	}]
				// }
			},
			list() {
				this.warehouseid = 0
				let goods = this.createtabledata(this.data)
				let statics = this.createstaticdata(goods)
				this.tabledata = goods.concat(statics)
				// console.log(goods)
				return new Promise((resolve) => {
					resolve({
						list: this.tabledata
					})
				})
			},
			createtabledata(data){
				let goods = data.map((item)=>{
					this.warehouseid = item.warehouseid
					this.policytype = item.policytype
					return {
						id:item.id,
						warehouseid:item.warehouseid,
						parentid:item.supplierwlnid,
						supplierID:item.supplierwlnid,
						supplierName:item.suppliername,
						warehouseID:item.warehousewlnid,
						warehouseName:item.warehousename,
						specCode:item.goodscode,
						goodsname:item.goodsname,
						goodsmodel:item.goodsmodel,
						price:item.taxprice,
						quantity:item.purchasenum,
						sum:(item.purchasenum * item.taxprice).toFixed(2),
						policytype:item.policytype,
						goodscode:item.goodscode,
						recommendlevel:item.recommendlevel,
						requirement:item.stock?item.stock:0,
						prochasestandards:item.prochasestandards,
						hitchhiking:item.hitchhiking?item.hitchhiking:0
					}
				})
				return goods
			},
			createstaticdata(data){
				let statics = this.$Lodash(data).groupBy('supplierID').map((group, key) => ({
					id:key,
					parentid:null,
					warehouseid:group[0].warehouseid,
					supplierID: key,
					supplierName: group[0].supplierName,
					warehouseID: group[0].warehouseID,
					warehouseName: group[0].warehouseName,
					specCode:group.length,
					quantity: this.$Lodash.sumBy(group, 'quantity'),
					sum: this.$Lodash.sumBy(group, (item)=>{
						return parseFloat(item.sum)
					}).toFixed(2),
					hitchhiking:this.$Lodash.sumBy(group, (item)=>{
						return parseFloat(item.hitchhiking)
					}),
					policytype:group[0].policytype
				})).value()		
				statics.forEach((item)=>{
					item.price = (item.sum/item.quantity).toFixed(4)
				})
				return statics
			},
			
			hitchhiking(){
				this.$refs.hitchhikingForm.modal_show()
			},
			regestevent(rule){
				rule.forEach((item) => {
					if (item.field) {
						let on = {}
						if (typeof this[item.field + 'Input'] === 'function') {
							on.input = this[item.field + 'Input']
						}
						if (typeof this[item.field + 'Change'] === 'function') {
							on.input = this[item.field + 'Change']
						}
						if (typeof this[item.field + 'Button'] === 'function') {
							on.inputButtonclick = this[item.field + 'Button']
						}				
						this.fApi.updateRule(item.field, {
							on: on
						})
					}				
				})
			},
			setFormData(){
				if(this.sourceData){
					let fields = this.fApi.fields()
					fields.forEach((item) => {
						this.fApi.setValue(item, this.sourceData[item])
					})
				}
			},
			getgrid(){
				return this.$refs.list
			},
			add(row){
				this.currentrow = row
				// console.log(this.currentrow)
				this.$nextTick(()=>{
					this.$refs.goodsBox.initList()
					this.$refs.goodsBox.box.alertBox()		
				})
				
			},
			delete(row){
				this.getgrid().remove(row)
				this.clearparentdata()
			},
			clearparentdata(){
				let unchilddata = []
				this.tabledata.forEach((item)=>{
					if(!item.parentid){
						item.quantity = this.$Lodash.sumBy(item.children, 'quantity'),
						item.sum = this.$Lodash.sumBy(item.children, (item)=>{
							return parseFloat(item.sum)
						}).toFixed(2)
						item.price = (item.sum/item.quantity).toFixed(4)
						
						if(!item.children.length){
							unchilddata.push(item)
						}
					}
				})
				this.getgrid().remove(unchilddata)
			},
			submit() {
				let data = this.tabledata.filter((item)=>{
					return !item.parentid
				})
				this.loading = true
				this.$api.stockwarning.uploadwln({data:data}).then(()=>{
					this.loading = false
					this.$emit('submit')
					this.modal_cancel()
					
				},()=>{
					this.loading = false
				})
			},
			reset() {
				//this.init()
			},
			hitchhikingFormSubmit(e){
				let data = e.map((item)=>{
					return {
						...item.sourcedata,
						id:item.id,
						hitchhiking:1,
					}
				})
				this.sourcedata = this.sourcedata.concat(data)
				console.log(this.sourcedata)
				let goods = this.createtabledata(this.sourcedata)
				let statics = this.createstaticdata(goods)
				this.tabledata = goods.concat(statics)
				this.getgrid().reloadData(this.tabledata)
				this.hitchhikingData = []
				console.log(this.tabledata)
			},
			goodsBoxSubmit(e){
				this.hitchhikingData = e.data.map((item)=>{
					return {
						id:item.id,
						goodscode:item.goodscode,
					}
				})
				this.$nextTick(()=>{
					this.hitchhiking()
				})
				
			},
			list_sum(field, data, toFixed) {
				let sum = 0
				if (this.statisticsfield) {
					if (this.sourcestatisticsdata[field]) {
						sum = this.sourcestatisticsdata[field]
					}
					return sum
				} else {
					data.forEach((item) => {
						for (let i in item) {
							if (i == field) {
								sum = sum + (isNaN(parseFloat(item[i])) ? 0 : parseFloat(item[i]))
							}
						}
					})
					return sum.toFixed(toFixed)
				}

			},
		},
		components: {
			hitchhikingForm,
			goodsBox
		}
	}
</script>